export enum DonatedTypes {
    pennies1,
    pennies5,
    pennies10
}